/**
 * External dependencies
 */
import { combineReducers } from 'redux';
/**
 * Internal dependencies
 */

import { createReducer } from 'state/utils';
import {
    PLAN_NAMES_RECEIVE,
    PLAN_NAMES_REQUEST,
    PLAN_NAMES_REQUEST_SUCCESS,
    PLAN_NAMES_REQUEST_FAILURE,
} from 'state/action-types';

export const items = createReducer({}, {
    [PLAN_NAMES_RECEIVE]: (state, action) => action.payload.items,
});

export const requesting = createReducer(false, {
    [PLAN_NAMES_REQUEST]: () => true,
    [PLAN_NAMES_REQUEST_SUCCESS]: () => false,
    [PLAN_NAMES_REQUEST_FAILURE]: () => false,
});

export const error = createReducer(false, {
    [PLAN_NAMES_REQUEST]: () => false,
    [PLAN_NAMES_REQUEST_SUCCESS]: () => false,
    [PLAN_NAMES_REQUEST_FAILURE]: () => true,
});

export default combineReducers({
    items,
    requesting,
    error
});
